/**
 * Finds the maximum element in an array based on a selector function
 */
export const maxBy = <T>(array: T[], selector: (item: T) => number): T | undefined => {
  if (array.length === 0) return undefined

  return array.reduce((max, current) => (selector(current) > selector(max) ? current : max))
}
